(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PresentListProduct', PresentListProduct);

    PresentListProduct.$inject = ['$resource'];

    function PresentListProduct ($resource) {
        var resourceUrl =  'api/present-list-products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
